module.exports = __webpack_public_path__ + "static/FrontStripe-6d18e815d3653535e7b2b8aca06c8b04.png";